








































import { RelanceApi } from "../api/RelanceApi";
import BalanceAgeeImportModal from "./RelanceListPartials/BalanceAgeeImportModal.vue";
import CollapsiblePanel from "../core/UI/CollapsiblePanel.vue";
import SyndicAccordion from "./RelanceListPartials/SyndicAccordion.vue";
import CoproprieteAccordion from "./RelanceListPartials/CoproprieteAccordion.vue";

export default {
    name: "RelanceList",
    components: {
        CoproprieteAccordion,
        SyndicAccordion,
        CollapsiblePanel,
        BalanceAgeeImportModal,
    },
    data() {
        return {
            factures: [],
            groupedFactures: {},
            sortedSyndics: [],
            RelanceApi: new RelanceApi(),
            showImportModal: false,
        };
    },
    created() {
        this.refreshFactures();
    },
    methods: {
        refreshFactures() {
            // Liste complète attendue (regroupement par syndic) : limite
            // explicite, le serveur tronquait silencieusement à 50.
            this.RelanceApi.getAll({
                include: "copropriete,syndic",
                limit: 100000,
            }).then((relances) => {
                this.factures = relances;
                this.groupFactures();
            });
        },
        groupFactures() {
            // Group by syndic
            this.groupedFactures = _.groupBy(this.factures, (relance) => {
                if (relance.syndic) {
                    return relance.syndic.nom;
                } else return "no-syndic";
            });

            // Group by copropriete within each syndic group
            _.each(this.groupedFactures, (relances, syndicName) => {
                this.groupedFactures[syndicName] = _.groupBy(
                    relances,
                    (relance) => {
                        if (relance.copropriete) {
                            return relance.copropriete.nom;
                        } else return "no-copropriete";
                    }
                );

                // Sort copropriétés within this syndic group
                const coproprieteNames = Object.keys(
                    this.groupedFactures[syndicName]
                );
                const sortedCoproprietes = this.sortWithSpecialAtEnd(
                    coproprieteNames,
                    "no-copropriete"
                );

                // Rebuild the copropriete object in sorted order
                const sortedCoproprieteData = {};
                sortedCoproprietes.forEach((name) => {
                    sortedCoproprieteData[name] =
                        this.groupedFactures[syndicName][name];
                });
                this.groupedFactures[syndicName] = sortedCoproprieteData;
            });

            // Sort syndics
            const syndicNames = Object.keys(this.groupedFactures);
            this.sortedSyndics = this.sortWithSpecialAtEnd(
                syndicNames,
                "no-syndic"
            );
        },

        sortWithSpecialAtEnd(items, specialItem) {
            const regularItems = items.filter((item) => item !== specialItem);
            const specialItems = items.filter((item) => item === specialItem);

            // Sort regular items alphabetically
            regularItems.sort((a, b) => a.localeCompare(b));

            // Return regular items first, then special items
            return [...regularItems, ...specialItems];
        },
        // Modal
        openImportModal() {
            this.showImportModal = true;
        },
        closeImportModal() {
            this.showImportModal = false;
            this.refreshFactures();
        },
        onRelanceUpdated(updatedRelance) {
            this.refreshFactures();
        },
    },
};
